<div class="container position-absolute">
    <app-table [data]="sealCompleted$ | async" [columns]="columns" [pageData]="sealCompletedPage$ | async"  [search]="true" [forChangeHistory]="true" (pageEvent)="getPage($event)" (searchEvent)="search($event)" [noAdd]="true" [isDeletable]="false" [isEditable]="false"></app-table>
</div>
<!-- <router-outlet></router-outlet> -->
